import { createInstance } from '../index'
import * as common from "../../utils/common";

// eslint-disable-next-line no-unused-vars
const instance = createInstance(3 * 1000);
const formUrlEncodedInstance = createInstance(3 * 1000, {key: 'Content-Type', value: 'application/x-www-form-urlencoded'});


export function getAccessTokenApi(code, redirectUri) {
    console.log(redirectUri)
    const requestBody = new URLSearchParams({
        'grant_type': 'authorization_code',
        'client_id': '7ec164ae91cb61ebb634d8490e9780ea',
        'redirect_uri': encodeURI(redirectUri),
        'client_secret': 'bz8SdSEC3lfnRiUDsBOpv5RujpXNWiLN',
        'code': code,
    })

    return formUrlEncodedInstance.post(common.urlWithQueryString('https://kauth.kakao.com/oauth/token'),requestBody);

}